var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1666 14.2497L19.5191 9.99967L12.1666 5.74967V14.2497ZM28.5433 3.15717C28.7275 3.82301 28.855 4.71551 28.94 5.84884C29.0391 6.98217 29.0816 7.95967 29.0816 8.80968L29.1666 9.99967C29.1666 13.1022 28.94 15.383 28.5433 16.8422C28.1891 18.1172 27.3675 18.9388 26.0925 19.293C25.4266 19.4772 24.2083 19.6047 22.3383 19.6897C20.4966 19.7888 18.8108 19.8313 17.2525 19.8313L15 19.9163C9.06415 19.9163 5.36665 19.6897 3.90748 19.293C2.63248 18.9388 1.81081 18.1172 1.45665 16.8422C1.27248 16.1763 1.14498 15.2838 1.05998 14.1505C0.960813 13.0172 0.918313 12.0397 0.918313 11.1897L0.833313 9.99967C0.833313 6.89717 1.05998 4.61634 1.45665 3.15717C1.81081 1.88217 2.63248 1.06051 3.90748 0.706341C4.57331 0.522175 5.79165 0.394674 7.66165 0.309674C9.50331 0.210508 11.1891 0.168008 12.7475 0.168008L15 0.0830078C20.9358 0.0830078 24.6333 0.309675 26.0925 0.706341C27.3675 1.06051 28.1891 1.88217 28.5433 3.15717Z",
    fill: "#1DA1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.69c618b2fce505ea9c146a4502376444.svg";
export { ForwardRef as ReactComponent };